import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userRegister, userLogin } from "../../actions";
import LoginForm from "./LoginForm";
import RegistrationForm from "./RegistrationForm";

class LoginFormContainer extends React.Component {
  state = {
    name: null,
    displayForm: "login",
  };

  handleUserLogin = (data) => {
    this.props.userLogin(data);

    this.setState({
      name: data.name,
    });
  };

  handleRegisterUser = (data) => {
    this.props.userRegister(data);
  };

  showRegistrationForm = () => {
    this.setState({
      displayForm: "register",
    });
  };

  showLoginForm = () => {
    this.setState({
      displayForm: "login",
    });
  };

  render() {
    const forgotPasswordName = this.state.name
      ? `?name=${this.state.name}`
      : ``;

    return (
      <div className="login-prompt__login">
        {this.state.displayForm === "login" && (
          <LoginForm
            forgotPasswordName={forgotPasswordName}
            error={this.props.error}
            handleUserLogin={this.handleUserLogin}
            showRegistrationForm={this.showRegistrationForm}
            registrationSuccess={this.props.registrationSuccess}
          />
        )}

        {this.state.displayForm === "register" && (
          <RegistrationForm
            handleRegisterUser={this.handleRegisterUser}
            showLoginForm={this.showLoginForm}
            registrationSuccess={this.props.registrationSuccess}
            registerError={this.props.registerError}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    error: state.user.logInError,
    registrationSuccess: state.user.registrationSuccess,
    registerError: state.user.registerError,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      userRegister: userRegister.request,
      userLogin: userLogin.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginFormContainer);
